import { RenderResult } from '@dojo/framework/core/interfaces';
import { create, tsx } from '@dojo/framework/core/vdom';
import * as css from './FAQ.m.css';
import ContentWrapper from './ContentWrapper';
import { Text } from './Text';

export interface FAQProperties {
	title: string;
}

export interface FAQChild {
	title: string;
	content: RenderResult;
}

const factory = create().properties<FAQProperties>().children<FAQChild[]>();

export const FAQ = factory(function FAQ({ children, properties, id }) {
	const { title } = properties();

	return (
		<ContentWrapper size="smaller">
			<div classes={css.titleContainer}>
				<Text type="section">{title}</Text>
			</div>

			{children().map(({ title, content }) => {
				return (
					<details classes={css.item}>
						<summary classes={[css.summary]}>
							<div classes={css.itemTitle}>
								<Text type="subhead" responsive="smaller-subhead">
									{title}
								</Text>
								<i classes="icon-chevron-down" />
							</div>
						</summary>
						<div classes={css.content}>
							<Text type="body">{content}</Text>
						</div>
					</details>
				);
			})}
		</ContentWrapper>
	);
});

export default FAQ;
